@if (!masque) {
	@if (loading) {
		<button [class]="'btn btn-icon btn-soft- ' + color">
			<div class="spinner-border" role="status"></div>
		</button>
	} @else {
		<button
			[routerLink]="routerLink"
			[hidden]="hidden"
			(click)="clicked.emit()"
			[class]="'btn btn-icon btn-soft-' + color + ' ' + class"
			[disabled]="disabled"
			[attr.aria-label]="ariaLabel"
			type="button"
		>
			<i [class]="icon" style="font-size: 18px"></i>
		</button>
	}
}
